function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, Select } from 'seagull';
import { billingTriggersTextsPath } from "../../../business-logic/billingLogic";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { useLocaleKeys } from "../../../i18n";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { getUpdatedTriggerIfInvalid } from "./BillingTrigger.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export function validatePricing(_ref) {
  let {
    pricing,
    recurrencePeriod
  } = _ref;
  if (recurrencePeriod === 'inStages' && pricing !== 'fixed') {
    return 'Must be fixed price for stages';
  }
  return true;
}
const pricingOptions = [{
  text: 'Fixed price',
  value: 'fixed',
  disabledOnBundle: false
}, {
  text: 'Price per hour',
  value: 'hour',
  disabledOnBundle: false
}, {
  text: 'Price per unit',
  value: 'unit',
  disabledOnBundle: false
}, {
  text: 'Price range',
  value: 'range',
  disabledOnBundle: true
}];
export default function PricingTextField(_ref2) {
  let {
    isBundle,
    testid,
    serviceOrigin,
    isExistingService = false
  } = _ref2;
  const {
    control,
    watch,
    trigger: triggerValidation,
    setValue,
    getValues
  } = useFormContext();
  const recurrencePeriod = watch('recurrencePeriod');
  const pricing = watch('pricing');
  const featureFlags = useFeatureFlags();
  const {
    t: billingTriggersTexts
  } = useLocaleKeys(billingTriggersTextsPath);
  useEffect(() => {
    triggerValidation('pricing');
  }, [recurrencePeriod, triggerValidation]);
  useEffect(() => {
    if (!serviceOrigin) return;
    const currentData = getValues();
    const updatedTrigger = getUpdatedTriggerIfInvalid({
      t: billingTriggersTexts,
      currentTrigger: currentData.trigger,
      pricing,
      recurrencePeriod,
      serviceOrigin,
      isExistingService,
      featureFlags
    });
    if (updatedTrigger) {
      setValue('trigger', updatedTrigger, {
        shouldDirty: true
      });
    }
  }, [pricing, recurrencePeriod, serviceOrigin, isExistingService, featureFlags, setValue, getValues, billingTriggersTexts]);
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "pricing",
    rules: {
      validate: pricing => validatePricing({
        pricing,
        recurrencePeriod
      })
    },
    render: renderProps => /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps, {
      alwaysShowErrors: true
    })), {}, {
      label: "Pricing",
      "data-testid": testid !== null && testid !== void 0 ? testid : 'sb-pricing',
      children: pricingOptions.map(_ref3 => {
        let {
          value,
          text,
          disabledOnBundle
        } = _ref3;
        return /*#__PURE__*/_jsx(MenuItem, {
          value: value,
          "data-testid": testid ? "".concat(testid, "-opt-").concat(value) : "sb-pricing-opt-".concat(value),
          disabled: isBundle && disabledOnBundle,
          tooltipProps: {
            title: isBundle && disabledOnBundle ? "".concat(text, " isn't supported for bundles") : ''
          },
          children: text
        }, value);
      })
    }))
  });
}